// eslint-disable-next-line no-restricted-imports
import { SaveLegalClientOpenAccountOrderByAdminDto_Input } from 'api/generated/graphql';
import { OpenAccountOrderParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

export const parseLegalClientOpenAccountOrderParam = (
  openAccountOrder: OpenAccountOrderParam
): SaveLegalClientOpenAccountOrderByAdminDto_Input => ({
  date: openAccountOrder.date ? formatToISODate(openAccountOrder.date) : null,
  number: openAccountOrder.number || null,
  orderReceivedDate: openAccountOrder.orderReceivedDate
    ? formatToISODate(openAccountOrder.orderReceivedDate)
    : null,
  fileId: openAccountOrder.fileId || null,
});
